export default "__VITE_ASSET__cf139d9a__"